import { Currencies } from '../../utils/enums';

export const FORM_NAME = 'createApplicationForm';

export const Currency = [
  Currencies.CAD,
  Currencies.USD,
];
